import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { RouterProvider } from 'react-router';

import { config } from './config';
import { main } from './configuration';
import { store } from './configuration/setup/store';
import { handleLoginRedirect } from './configuration/login/redirect';
import { ErrorBoundary } from './components/ErrorBoundary';
import { router } from './routes/Router';
import type { User } from 'oidc-client-ts';
import { InvalidLogin } from './components/InvalidLogin.tsx';

const renderApplication = ({ user }: { user: User | null }) => {
    const container = document.getElementById('root');
    // biome-ignore lint/style/noNonNullAssertion: suppress out of convenience when switching to biomejs
    const root = createRoot(container!);

    let showApp = true;
    try {
        showApp = user?.profile.sub.startsWith('azure-my-rio-de:') ?? false;
    } catch (e) {
        console.error(e);
    }

    if (showApp) {
        root.render(
            <ErrorBoundary>
                <Provider store={store}>
                    <RouterProvider router={router} />
                </Provider>
            </ErrorBoundary>
        );
    } else {
        root.render(<InvalidLogin />);
    }
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    if (config.isIntegrationTest) {
        // for integration tests the mock server is started in the test configuration
        // that way we can control the responses
        main(renderApplication);
    } else {
        import('../mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
    }
}

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect();
} else if (isProd && !isProdPreview) {
    main(renderApplication);
}
